import axios from 'axios';
import FileDownload from 'react-file-download';

const stub = () => {};

const errorMsgHandler = ({ failure = stub, onComplete = stub }) => ({ response }) => {
  failure(response?.data?.message);
  onComplete();
};

const successResultHandler = ({
  success = stub,
  responseType = stub,
  onComplete = stub,
  filename,
}) => (response) => {
  if (responseType === 'blob') {
    FileDownload(response.data, filename);
    success();
    onComplete();
  } else {
    success(response.data);
    onComplete();
  }
};

export const get = ({
  url, token, params, success, failure, responseType = 'json',
  accept, onComplete = () => {}, filename,
}) => {
  axios.get(
    url,
    {
      params,
      responseType,
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${accept || responseType}`,
        Authorization: `Bearer ${token}`,
      },
    },
  ).then(successResultHandler({
    success, responseType, onComplete, filename,
  })).catch(errorMsgHandler({ failure, onComplete }));
};

export const post = ({
  url, token, responseType = 'json', success, failure, body, onComplete = () => {}, params = {}
}) => {
  axios.post(
    url,
    body,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${responseType}`,
        Authorization: `Bearer ${token}`,
      },
    },
  ).then(successResultHandler({ success, onComplete }))
    .catch(errorMsgHandler({ failure, onComplete }));
};

export const put = ({
  url, token, responseType = 'json', success, failure, body, onComplete = () => {},
}) => {
  axios.put(
    url,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${responseType}`,
        Authorization: `Bearer ${token}`,
      },
    },
  ).then(successResultHandler({ success, onComplete }))
    .catch(errorMsgHandler({ failure, onComplete }));
};

export const del = ({
  url, token, responseType = 'json', success, failure, onComplete = () => {}, params = {}
}) => {
  axios.delete(
    url,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${responseType}`,
        Authorization: `Bearer ${token}`,
      },
    },
  ).then(successResultHandler({ success, onComplete }))
    .catch(errorMsgHandler({ failure, onComplete }));
};
